import React, { render, Component } from 'preact';


export default class Offers extends Component {

    constructor(props) {
        super(props);

        this.state = {};
        this.state.offers = [];
        if (window.offers) {
            this.state.offers = window.offers;
        }
    }

    rightSide(offer) {

        if(offer.soldOut){
            return (<div className="offer-info-right">
            <div className="display-sold-out">Sold Out</div>
 
            
        </div>)
        }

        return (<div className="offer-info-right">
            <div className={`${offer.show ? "display-daysleft-show urgent" : "display-daysleft-hide"}`}>{offer.daysLeftText}</div>
            <div className="fifteen-font-size">Valid until {offer.ValidUntil}</div>
            <div className="fifteen-font-size"><span style={{ color: "red" }}>{offer.TakenOffers}</span> of {offer.TotalOffers} taken</div>
            <a href={`/offer/${offer.OfferURL}`} className="details-button">Details</a>
        </div>)
    }


    getDaysLeftText(offer){
        if (offer.daysLeft < 4) {
            offer.show = true;
        } else {
            offer.show = false;
        }
        offer.daysLeftText = "Ends Today!";
        if (offer.daysLeft == 1) {
            offer.daysLeftText = `Only ${offer.daysLeft} day left`
        }
        if (offer.daysLeft > 1) {
            offer.daysLeftText = `Only ${offer.daysLeft} days left`
        }

        if (offer.TakenOffers == offer.TotalOffers) {
            offer.soldOut = true;
            offer.daysLeftText = `Sold Out`;
        }
    }

    render() {
        return (
            <div id="offers">
                {
                    this.state.offers.map((offer) => {
                        console.log(offer)
                        this.getDaysLeftText(offer);

                        return (
                            <div className="offer">
                                <div className="image-section">
                                    <div className="image-holder"><img className="background-image" src={`/img/${offer.Image}` || "/img/flashtest.jpg"} /></div>
                                    <div className="image-price"><span className="old-price-offer">${offer.OldPrice}</span><div>${offer.Price}</div>  <div>per Night</div></div>
                                </div>
                                <div style={{ background: offer.BackgroundColor }} className="room-name-holder">
                                    <div></div> <div style={{ background: offer.Color }} className="room-name">{offer.RoomName}</div>
                                </div>
                                <div className="offer-info-row">
                                    <div className="offer-info-left">
                                        <div className="offer-info-date"> {offer.Arrival} - {offer.Departure}</div>
                                        <div className="offer-info-night-count">{offer.NightCount} nights</div>
                                    </div>
                                    {
                                        this.rightSide(offer)
                                    }
                                </div>
                            </div>
                        )
                    })
                }
                {
                    this.state.offers.length === 0 ? <div>Error Occured</div> : ""
                }



            </div>
        )
    }
}